import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type TemplateAssignmentsFetchFailedAction = {
	type: 'TEMPLATE_ASSIGNMENTS_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): TemplateAssignmentsFetchFailedAction => ({
	type: 'TEMPLATE_ASSIGNMENTS_FETCH_FAILED',
	payload,
});
